<template>
  <rule-form />
</template>

<script>
  export default {
    name: 'NewRule',

    components: {
      RuleForm: () => import('../components/RuleForm'),
    },

    props: {
      currentRouteName: String,
    },
  }
</script>
